import { useEffect, useRef, useState } from "react";
import ReactCountryFlag from "react-country-flag";
import { ChevronDown, ChevronUp, X } from "react-feather";
import commaFormat from "../../../../../utils/commaFormat";
import ViewAllFilter from "./viewAll-filter";
import ReactTooltip from "react-tooltip";
import IncludeExcludeFilter from "./includeExcludeFilter.jsx";
import { formatStringCase, useDebounce } from "@utils/utils";
import LoaderImg from "@assets/images/loader.gif";
import { useDispatch, useSelector } from "react-redux";
import { selectedFilterListHandler } from "@redux/Shipment/shipmentSlice";

const LocaliseViewAll = ({ placeholder, noDataFound, setNoDataFound, onApply, closeFilter, filterList, emptyContent, filterKeyword, heading, label, includeFilter, isLowerCase, excludeFilter, appliedFilterList, getFilterDataHandler, filterDetails, searchedData }) => {
  const filterLoader = useSelector((state) => state.shipmentDetails.filterLoader);
  const [includeFilterButton, setIncludeFilterButton] = useState("true");
  const [filterData, setFilterData] = useState([]);
  const [inputValue, setInputValue] = useState(null);
  const [isLoaderActive, setIsLoaderActive] = useState(false);
  const [selectedFilterIds, setSelectedFilterIds] = useState({});
  const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
  const debouncedInputValue = useDebounce(inputValue, 500);
  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const appliedFilterListNew = useSelector((state) => state?.shipmentDetails?.selectedFilterList);

  const [expandedIds, setExpandedIds] = useState({});
  useEffect(() => {
    if (includeFilter.includes(filterKeyword)) {
      setIncludeFilterButton("true");
    } else if (excludeFilter.includes(filterKeyword)) {
      setIncludeFilterButton("false");
    }
    setNoDataFound(false);
  }, []);

  const changeIncludeExcludeSelection = (data) => {
    setIncludeFilterButton(data);
  };
  useEffect(() => {
    if (debouncedInputValue || debouncedInputValue === "") {
      setFilterData([]);
      setNoDataFound(false);
      getFilterDataHandler(filterDetails, undefined, debouncedInputValue);
    }
  }, [debouncedInputValue]);

  useEffect(() => {
    setIsLoaderActive(true);
    const selectedList = searchedData?.length > 0 || inputValue?.length > 0 ? searchedData : filterList ? filterList : [];
    if (selectedList.length > 0) {
      let selectedFilterIdsTempSet = { ...selectedFilterIds };
      let filterDataClone = JSON.parse(JSON.stringify(selectedList));
      let appliedFilterListNewClone = appliedFilterListNew[filterDetails.key];
      let isSelected = true;
      let searchRegionalizationFilterClone = [];
      for (let i = 0; i < filterDataClone.length; i++) {
        let regionSearch = filterDataClone[i]?.region;
        searchRegionalizationFilterClone.push({ ...filterDataClone[i], region: regionSearch });

        if (selectedFilterIdsTempSet[filterDataClone[i].key]) {
          searchRegionalizationFilterClone[i]?.region?.forEach((childRegion) => {
            if (selectedFilterIdsTempSet[filterDataClone[i].key].has(childRegion.key)) {
              childRegion.isChecked = true;
            }
          });
          searchRegionalizationFilterClone[i].isChecked = searchRegionalizationFilterClone[i]?.region.length > 0 && searchRegionalizationFilterClone[i]?.region?.every((childRegion) => childRegion.isChecked);
        }
        if (appliedFilterList.length > 0) {
          searchRegionalizationFilterClone[i]?.region?.forEach((region) => {
            if (appliedFilterList.includes(region.key)) {
              region.isChecked = true;
              if (selectedFilterIdsTempSet[searchRegionalizationFilterClone[i].key]) {
                selectedFilterIdsTempSet[searchRegionalizationFilterClone[i].key].add(region?.key);
              } else {
                selectedFilterIdsTempSet[searchRegionalizationFilterClone[i].key] = new Set();
                selectedFilterIdsTempSet[searchRegionalizationFilterClone[i].key].add(region?.key);
              }
            }
          });
          searchRegionalizationFilterClone[i].isChecked = searchRegionalizationFilterClone[i]?.region?.length > 0 && searchRegionalizationFilterClone[i]?.region?.every((childRegion) => childRegion.isChecked);
        }
      }
      if (Object.keys(appliedFilterListNewClone || {}).length > 0) {
        Object.keys(appliedFilterListNewClone || {}).map((item) => {
          if (!selectedList.some((data) => data.key === item)) {
            searchRegionalizationFilterClone.push({
              key: item,
              doc_count: 0,
              isChecked: true,
              region: appliedFilterListNewClone[item].map((country, index) => ({ key: country, doc_count: 0, id: index, isChecked: true })),
            });
          } else {
            for (let i = 0; i < searchRegionalizationFilterClone.length; i++) {
              if (searchRegionalizationFilterClone[i].key === item && searchRegionalizationFilterClone[i].region && searchRegionalizationFilterClone[i].region?.length) {
                appliedFilterListNewClone[item].forEach((region, index) => {
                  if (!searchRegionalizationFilterClone[i].region.some((child) => child.key === region)) {
                    searchRegionalizationFilterClone[i].region.push({
                      key: region,
                      doc_count: 0,
                      id: index,
                      isChecked: true,
                    });
                  }
                });
              }
            }
          }
          appliedFilterListNewClone[item].forEach((region) => {
            if (selectedFilterIdsTempSet[item]) {
              selectedFilterIdsTempSet[item].add(region);
            } else {
              selectedFilterIdsTempSet[item] = new Set();
              selectedFilterIdsTempSet[item].add(region);
            }
          });
        });
      }
      for (let i = 0; i < searchRegionalizationFilterClone.length; i++) {
        if (!searchRegionalizationFilterClone[i].isChecked && searchRegionalizationFilterClone[i].region?.length) {
          isSelected = false;
          break;
        }
      }
      setSelectedFilterIds(selectedFilterIdsTempSet);
      setIsSelectAllChecked(isSelected);
      setFilterData(searchRegionalizationFilterClone);
      setIsLoaderActive(false);
      setExpandedIds({ [selectedList?.[0]?.key]: true });
    }
    setIsLoaderActive(false);
  }, [searchedData, filterList]);

  const selectParentCheckboxHandler = (checked, key) => {
    const selectedFilterIdsTempSet = { ...selectedFilterIds };
    let isSelected = true;
    const selectedList = filterData ? filterData : [];
    const filterDataClone = JSON.parse(JSON.stringify(selectedList));
    filterDataClone.forEach((data) => {
      if (data.key === key) {
        data.isChecked = checked;
        data?.region?.forEach((region) => {
          region.isChecked = checked;
          if (checked) {
            if (selectedFilterIdsTempSet[key]) {
              selectedFilterIdsTempSet[key].add(region?.key);
            } else {
              selectedFilterIdsTempSet[key] = new Set();
              selectedFilterIdsTempSet[key].add(region?.key);
            }
          } else {
            if (selectedFilterIdsTempSet[key].has(region?.key)) {
              selectedFilterIdsTempSet[key].delete(region?.key);
            }
          }
        });
      }
    });
    for (let i = 0; i < filterDataClone.length; i++) {
      if (!filterDataClone[i].isChecked && filterDataClone[i].region?.length) {
        isSelected = false;
        break;
      }
    }
    setFiltersStateHandler(selectedFilterIdsTempSet);
    setIsSelectAllChecked(isSelected);
    setFilterData(filterDataClone);
    setSelectedFilterIds(selectedFilterIdsTempSet);
  };

  const onSelectHandler = (checked, parentKey, childKey) => {
    const selectedFilterIdsTempSet = { ...selectedFilterIds };
    const selectedList = filterData ? filterData : [];
    const filterDataClone = JSON.parse(JSON.stringify(selectedList));
    let isSelected = true;
    filterDataClone.forEach((data) => {
      if (data.key === parentKey) {
        data?.region?.forEach((region) => {
          if (region?.key === childKey) {
            region.isChecked = checked;
            if (checked) {
              if (selectedFilterIdsTempSet[parentKey]) {
                selectedFilterIdsTempSet[parentKey].add(region?.key);
              } else {
                selectedFilterIdsTempSet[parentKey] = new Set();
                selectedFilterIdsTempSet[parentKey].add(region?.key);
              }
            } else {
              if (selectedFilterIdsTempSet[parentKey].has(region?.key)) {
                selectedFilterIdsTempSet[parentKey].delete(region?.key);
              }
            }
          }
        });
        data.isChecked = data.region.every((child) => child.isChecked);
      }
    });

    for (let i = 0; i < filterDataClone.length; i++) {
      if (!filterDataClone[i].isChecked && filterDataClone[i].region.length) {
        isSelected = false;
        break;
      }
    }
    setFiltersStateHandler(selectedFilterIdsTempSet);
    setIsSelectAllChecked(isSelected);
    setFilterData(filterDataClone);
    setSelectedFilterIds(selectedFilterIdsTempSet);
  };

  const onSelectAllHandler = (checked) => {
    const selectedList = filterData ? filterData : [];
    let searchFilterDataClone = JSON.parse(JSON.stringify(selectedList));
    let selectedFilterIdsTempSet = { ...selectedFilterIds };
    searchFilterDataClone.forEach((parent) => {
      parent.isChecked = checked;
      parent.region?.forEach((region) => {
        region.isChecked = checked;
        if (checked) {
          if (selectedFilterIdsTempSet[parent.key]) {
            selectedFilterIdsTempSet[parent.key].add(region.key);
          } else {
            selectedFilterIdsTempSet[parent.key] = new Set();
            selectedFilterIdsTempSet[parent.key].add(region.key);
          }
        } else {
          if (selectedFilterIdsTempSet[parent.key].has(region.key)) {
            selectedFilterIdsTempSet[parent.key].delete(region.key);
          }
        }
      });
    });

    setFiltersStateHandler(selectedFilterIdsTempSet);
    setFilterData(searchFilterDataClone);
    setSelectedFilterIds(selectedFilterIdsTempSet);
    setIsSelectAllChecked(true);
  };

  const setFiltersStateHandler = (selectedFilterIdsTempSet) => {
    let fltrLstClone = JSON.parse(JSON.stringify(filterData));
    fltrLstClone.forEach((parent) => {
      if (selectedFilterIdsTempSet[parent.key]) {
        parent.region?.forEach((child) => {
          if (selectedFilterIdsTempSet[parent.key].has(child.key)) {
            child.isChecked = true;
          } else {
            child.isChecked = false;
          }
          parent.isChecked = parent.region.every((child) => child.isChecked);
        });
      }
    });
    setFilterData(fltrLstClone);
  };

  const onApplyHandler = () => {
    let selectedFilterListArray = [];
    Object.keys(selectedFilterIds).map((parent) => {
      selectedFilterListArray = [...[...selectedFilterIds[parent]], ...selectedFilterListArray];
    });
    onApply(includeFilterButton, filterList, selectedFilterListArray);
    let selectedFilterIdsTemp = {};
    Object.keys(selectedFilterIds).map((parent) => {
      selectedFilterIdsTemp[parent] = Array.from(selectedFilterIds[parent]);
    });
    let tempAppliedSelectedList = JSON.parse(JSON.stringify(appliedFilterListNew));
    tempAppliedSelectedList[filterDetails.key] = selectedFilterIdsTemp;
    dispatch(selectedFilterListHandler(tempAppliedSelectedList));
  };

  const removePillHandler = (parent, child) => {
    let selectedFilterIdsTempSet = { ...selectedFilterIds };
    let filterDataClone = JSON.parse(JSON.stringify(filterData));
    let isSelected = true;
    const parentListClone = filterDataClone?.find((val) => val?.key === parent);
    if (!parentListClone) return;
    const childListClone = parentListClone?.region?.find((item) => item?.key === child);
    if (childListClone) {
      childListClone.isChecked = false;
    }
    parentListClone.isChecked = parentListClone?.region?.every((child) => child?.isChecked);

    for (let i = 0; i < filterDataClone.length; i++) {
      if (!filterDataClone[i]?.isChecked && filterDataClone[i]?.region?.length) {
        isSelected = false;
        break;
      }
    }
    setIsSelectAllChecked(isSelected);
    selectedFilterIdsTempSet[parent]?.delete(child);
    setFilterData(filterDataClone);
    setFiltersStateHandler(selectedFilterIdsTempSet);
  };

  const handleExpansion = (data) => {
    const tempExpandedIds = { ...expandedIds };
    if (tempExpandedIds[data?.key]) {
      tempExpandedIds[data?.key] = false;
    } else {
      tempExpandedIds[data?.key] = true;
    }
    setExpandedIds(tempExpandedIds);
  };
  return (
    <div className="tw-w-full tw-flex tw-flex-col tw-relative">
      <div className="tw-w-full tw-bg-[#00000008] tw-p-2.5 tw-border-b tw-border-gray-300 tw-flex tw-justify-between tw-items-center tw-sticky tw-top-0">
        <div className="tw-text-base tw-font-medium tw-pl-3">{heading || placeholder}</div>
        <button type="button" className="btn btn-primary btn-sm trademo-new-btn" onClick={onApplyHandler}>
          Apply Filter
        </button>
        <button type="button" className="tw-rounded-full tw-bg-white tw-absolute -tw-right-7 -tw-top-5" aria-label="Close" onClick={closeFilter.bind(this)}>
          <span aria-hidden="true" className="tw-p-1 tw-text-xl tw-h-6 tw-w-6 tw-rounded-full tw-text-gray-900 tw-flex tw-items-center tw-justify-center">
            &times;
          </span>
        </button>
      </div>
      <div className="tw-flex tw-flex-col tw-gap-2 tw-h-[65vh] tw-overflow-scroll ">
        <div className="tw-px-2">
          <IncludeExcludeFilter includeFilter={includeFilter.includes(filterKeyword)} excludeFilter={excludeFilter.includes(filterKeyword)} setIncludeFilter={(data) => changeIncludeExcludeSelection(data)} />
          {filterList?.length > 0 ? (
            <div className="col-md-5 pl-0 mt-2 mb-4 pl-3">
              <input
                className="form-control"
                type="text"
                placeholder={placeholder}
                ref={inputRef}
                onChange={(e) => {
                  setInputValue(e.target.value);
                  setIsLoaderActive(true);
                }}
              />
            </div>
          ) : null}
          <div className="d-flex flex-wrap mb-2 pl-3" data-for="appliedExporterCapsule">
            {Object.keys(selectedFilterIds).map((item) =>
              [...selectedFilterIds[item]].map((val) => (
                <div onClick={() => removePillHandler(item, val)} key={val} data-for="newtooltip" data-tip={item} className="mb-2 mr-1 green-capsule tw-border tw-rounded-3xl">
                  {!!val.length > 0 ? <span className="badge filter-no tw-pl-2 tw-uppercase">{val.includes("$$") ? val.split("$$")[1] : val}</span> : <></>}
                  <span className="badge">
                    <X size={14} color="#5A1CE2" className="cursor-pointer" />
                  </span>
                </div>
              ))
            )}
          </div>
        </div>
        {isLoaderActive || filterLoader ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: "calc(100% - 146px)" }}>
            <img src={LoaderImg} alt="description of gif" />
          </div>
        ) : !noDataFound ? (
          <>
            {filterList.length > 0 && searchedData.length > 0 && !noDataFound && (
              <div className="tw-border-b tw-border-gray-300 tw-flex tw-justify-between tw-items-center tw-cursor-pointer tw-px-4">
                <div className="tw-p-2 tw-flex tw-items-center tw-w-full tw-gap-2 tw-relative tw-text-sm tw-font-semibold tw-capitalize">
                  <input
                    className="after:!tw-top-2.5 after:!tw-left-1.5 after:!tw-w-4 after:!tw-h-4 after:!tw-border"
                    type="checkbox"
                    checked={isSelectAllChecked}
                    onChange={(e) => {
                      onSelectAllHandler(e.target.checked);
                      setIsSelectAllChecked(e.target.checked);
                    }}
                  />
                  <div>Select All</div>
                </div>
              </div>
            )}
            {filterData?.map((region) => (
              <div key={region.key} className="tw-flex tw-flex-col tw-gap-2 tw-px-4">
                <div className="tw-border-b tw-border-gray-300 tw-flex tw-justify-between tw-items-center tw-cursor-pointer" onClick={() => handleExpansion(region)}>
                  <div className="tw-p-2 tw-flex tw-items-center tw-w-full tw-gap-2 tw-relative tw-text-sm tw-font-semibold tw-capitalize">
                    <input
                      className="after:!tw-top-2.5 after:!tw-left-1.5 after:!tw-w-4 after:!tw-h-4 after:!tw-border"
                      checked={region.isChecked}
                      value={region.isChecked}
                      type="checkbox"
                      onClick={(e) => {
                        e.stopPropagation();
                        selectParentCheckboxHandler(e.target.checked, region.key);
                      }}
                    />
                    <div>{region?.key}</div>
                    <div>({commaFormat(region?.doc_count)})</div>
                  </div>
                  <div>{expandedIds[region.key] ? <ChevronUp size={20} color="#1a1722" /> : <ChevronDown size={20} color="#1a1722" />}</div>
                </div>

                <div className="tw-w-full tw-flex tw-flex-wrap tw-items-center tw-mx-2">
                  {region?.region?.length > 0 && expandedIds[region.key] ? (
                    region.region.map((country) => (
                      <span className="tw-flex tw-items-baseline tw-break-words tw-p-2 tw-w-1/3 tw-gap-2 tw-relative tw-text-sm tw-capitalize" key={`${country.key}_${region.key}`}>
                        <input
                          className="after:!tw-top-2.5 after:!tw-left-1.5 after:!tw-w-4 after:!tw-h-4 after:!tw-border"
                          type="checkbox"
                          checked={country.isChecked}
                          onChange={(e) => {
                            onSelectHandler(e.target.checked, region.key, country.key);
                          }}
                        />
                        <span className="tw-flex tw-items-center tw-gap-1 tw-font-medium tw-pl-1 tw-text-sm">
                          {country.countryCode && <ReactCountryFlag countryCode={country.countryCode} svg />}
                          {country.description ? (
                            <span data-for="localize-filter-tooltip" data-tip={country.description !== "" && typeof country.description === "string" && country.description.length > 100 ? country.description.toLowerCase() : ""}>
                              {formatStringCase(country.description.slice(0, 100), false, false, isLowerCase)}
                              {country?.description?.length > 100 ? "..." : ""}
                              <span> ({(!!country.doc_count || country.doc_count === 0) && typeof country.doc_count === "number" ? commaFormat(country.doc_count) : country.doc_count ? country.doc_count : ""})</span>
                            </span>
                          ) : (
                            <span data-for="localize-filter-tooltip" data-tip={country.key !== "" ? country.key.toLowerCase() : "Not Available"}>
                              {formatStringCase(country.key.slice(0, 100), false, false, isLowerCase)}
                              {country?.key?.length > 100 ? "..." : ""}
                              <span> ({(!!country.doc_count || country.doc_count === 0) && typeof country.doc_count === "number" ? commaFormat(country.doc_count) : country.doc_count ? country.doc_count : ""})</span>
                            </span>
                          )}
                        </span>
                      </span>
                    ))
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            ))}
          </>
        ) : (
          noDataFound && <ViewAllFilter content={emptyContent} filterKeyword={filterKeyword} label={label} />
        )}
      </div>
      <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id={"localize-filter-tooltip"} />
    </div>
  );
};

export default LocaliseViewAll;
